module.exports = __webpack_public_path__ + "img/rex-analytics-logo.e29fb7d9.svg";